import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';
import { PopoverController } from '@ionic/angular';

import { LoginPageRoutingModule } from './login-routing.module';

import { LoginPage } from './login.page';
import { MasterFooterModule } from '../master/master-footer/master-footer.module';
import { HelpContentComponent } from './help-content/help-content.component';
import { TermsPage } from './terms/terms.page';
import { CustomInputModule } from '../master/common-components/custom-input/custom-input.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    ReactiveFormsModule,
    LoginPageRoutingModule,
    MasterFooterModule,
    CustomInputModule
  ],
  declarations: [LoginPage, HelpContentComponent, TermsPage],
})
export class LoginPageModule {}
